import { Box, Button, ButtonGroup } from '@chakra-ui/react';

import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PositionedItem } from '../PageConfigProvider/types/item';

type ArrowDirectionSelectorProps = {
  item: PositionedItem;
  isDisabled?: boolean;
};

export const ArrowDirectionSelector = ({
  item,
  isDisabled = false,
}: ArrowDirectionSelectorProps) => {
  const { dispatch } = useTabContentConfig();
  const id = item?.id;
  const arrowOrientation =
    item?.plot?.divergingBar?.arrowOrientation ?? 'horizontal';

  const handleArrowOrientationChange = (
    newOrientation: 'horizontal' | 'vertical'
  ) => {
    if (id && arrowOrientation !== newOrientation) {
      dispatch({
        type: 'UPDATE_ITEM_DIVERGING_BAR',
        payload: {
          id,
          divergingBar: {
            ...item?.plot?.divergingBar,
            arrowOrientation: newOrientation,
          },
        },
      });
    }
  };

  return (
    <Box marginBottom="1.5rem">
      <ButtonGroup
        size="sm"
        isAttached
        variant="outline"
        isDisabled={isDisabled}
      >
        <Button
          colorScheme={arrowOrientation === 'horizontal' ? 'green' : 'gray'}
          variant={arrowOrientation === 'horizontal' ? 'solid' : 'outline'}
          onClick={() => handleArrowOrientationChange('horizontal')}
          flex={1}
        >
          Horizontal
        </Button>
        <Button
          colorScheme={arrowOrientation === 'vertical' ? 'green' : 'gray'}
          variant={arrowOrientation === 'vertical' ? 'solid' : 'outline'}
          onClick={() => handleArrowOrientationChange('vertical')}
          flex={1}
        >
          Vertical
        </Button>
      </ButtonGroup>
    </Box>
  );
};
